import {isWithinDaysFromNow, isWithinYearsFromNow, formatDate} from '../DateUtil'
import compact from 'lodash/compact'
import Productable from '../concerns/Productable'

export default function Subscription (lineItem, enrollment) {
  const self = {
    belongsTo: (username) => {
      return enrollment && (enrollment.owner == username || enrollment.assigned_to == username)
    },
    id: lineItem && lineItem.idWithIndex || enrollment && enrollment.id,
    status: enrollment && enrollment.status,
    enrollmentId: enrollment && enrollment.id,
    assignedToEmail: enrollment && enrollment.assigned_to_email,
    assignedToName: enrollment && enrollment.assigned_to_name,
    endAt: enrollment && (enrollment.end_at || enrollment.section_end_at),
    // shopper#391 : use section_start_at if greater than enrollment.startAt
    startAtDate: enrollment && (enrollment.sectionStartAtDate > enrollment.startAtDate ? enrollment.sectionStartAtDate : enrollment.startAtDate),
    startAt: enrollment && (enrollment.sectionStartAtDate > enrollment.startAtDate ? enrollment.sectionStartAt : enrollment.startAt),
    error: lineItem && lineItem.error,
    sku: (enrollment && enrollment.sku) || (lineItem && lineItem.sku),
    isFreeTrial: enrollment && enrollment.isFreeTrial,
    isUserAssignedRegistration: enrollment && enrollment.isUserAssignedRegistration,
    isThirdParty: lineItem && lineItem.isThirdParty,
    isInstructorCourse: lineItem && lineItem.isInstructorCourse,
    isClassroom: (lineItem && lineItem.isClassroom) || (enrollment && enrollment.isClassroom),
    isTemp: lineItem && lineItem.isTemp || enrollment && enrollment.isTemp,
    discount: lineItem && lineItem.discount,
    isRoleTeacher: enrollment && enrollment.isRoleTeacher,
    isRoleStudent: enrollment && enrollment.isRoleStudent,
    isMyCourse: (user) => !enrollment || (!enrollment.belongsToOther(user) && (enrollment.isNotAssigned || enrollment.isAssignedToUser(user))),
    isMyStudentCourse: (user) => enrollment && !enrollment.belongsToOther(user) && enrollment.isAssignedToOther(user),
    isStudentCourse: (user) => enrollment && enrollment.belongsToOther(user),
    isStudent: (user) => enrollment && enrollment.ownedByOther(user) && enrollment.isAssignedToUser(user),
    orderId: (lineItem && lineItem.order_id) || (enrollment && enrollment.shopify_order_id),
    subscription_plan_id: (lineItem && lineItem.subscription_plan_id),
    lineItemId: (lineItem && lineItem.id) || (enrollment && enrollment.shopify_item_id),
    lineItemQuantity: lineItem && lineItem.quantity,
    lineItemIndex: lineItem && lineItem.index,
    sectionId: (lineItem && lineItem.section_id) || (enrollment && enrollment.section_id),
    isRecurring: lineItem && lineItem.isRecurring,
    isPermanent: lineItem && lineItem.isPermanent,
    code: lineItem && lineItem.code,
    isEnrolled: !!enrollment,
    needsPayment: lineItem && lineItem.needsPayment,
    isFromCanvas: enrollment && enrollment.host && !enrollment.host.match(/(my|learn).thinkwell.com/),
    lastActivityAt: enrollment && enrollment.last_activity_at,
    overallGrade: enrollment && enrollment.overall_grade,
    properties: lineItem && lineItem.properties,
    lineItem: lineItem,
    enrollment: enrollment
  }

  self.isMonthly = self.isRecurring && self.isPermanent

  self.assignedToDisplay = `${self.assignedToName}, ${self.assignedToEmail}`

  self.isActive = !self.needsPayment

  self.skuOfficeHour = self.sku && self.sku.replace(/_SUB_FULL/i, "_OH").toUpperCase()

  self.title = (products, subscriptionCodes) => {
    const product = Productable.product(products, self)
    if (!enrollment && lineItem && lineItem.isThirdParty(subscriptionCodes) && lineItem.index(subscriptionCodes) > 1) {
      return ''
    } else if (self.isClassroom) {
      return (enrollment && enrollment.title) || (lineItem && lineItem.title)
    } else {
      return (product && product.title) || (lineItem && lineItem.title) || enrollment.title
    }
  }

  self.isUnassigned = (subscriptionCodes) => {
    if (lineItem && !enrollment && !lineItem.isThirdParty(subscriptionCodes)) {
      return true
    } else if (enrollment && enrollment.status == "not_assigned") {
      return true
    } else {
      return false
    }
  }

  return self
}
